import _ from 'lodash';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const getPairs = (
  entries: URLSearchParams,
  field: string,
  value: any
) => {
  const listOfEntries = [];
  for (const entry of entries.entries()) {
    listOfEntries.push(entry);
  }
  return { ..._.fromPairs(listOfEntries), [field]: value };
};
